/**
 * 列举webx.js的所有对外api
 * 这些api根据底层环境的差异，有些是跨端，有些非跨端。但这里是个全集
 */
const apiList = [
    /** xenv */
    'xenv',
    'is',
    /* isHK */
    'isHK',
    /** init */
    'init',
    /** login */
    'isLogin',
    'login',
    'loginCheckPhone',
    'setLoginConfig',
    'logout',
    'loginSDK',
    /** locate */
    'locate',
    /** share */
    'invokeShare',
    'setShare',
    /** omega */
    'trackEvent',
    'setOmegaConfig',
    'setOmegaAttrs',
    'sendXspmScan',
    'sendXspmClick',
    'trackPageShow',
    'trackResourceEvent',
    'trackResourceExposure',
    'getOmega',
    /** request */
    'request',
    'get',
    'post',
    'postEncrypt',
    /** webx */
    'getPageConfig',
    'getShareConfig',
    'getXaidConfig',
    'getSessionParams',
    /** goTo */
    'goTo',
    /** subscribe */
    'subscribeInit',
    'tryToSubscribe',
    'getAlwaysSubscribeStatus',
    'subscribe',
    /** query */
    'build',
    'buildSearch',
    'hashBuild',
    'query',
    'hashQuery',
    'parseURL',
    /** openid */
    'getOpenid',
    /** bridge */
    'bridge',
    'dbridge',
    'weixinReady',
    'alipayReady',
    'weixinmpReady',
    'alimpReady',
    'mqqReady',
    /** loader */
    'loadScript',
    'sdkReady',
    /** saveImg */
    'saveImg',
    /** storage */
    'storage',
    /** envInfo */
    'getEnvInfo',
    /** userInfo */
    'userInit',
    'reportUserInfo',
    'queryReportStatus',
    /** pay */
    'pay',
    'getPayInfo',
    /** launchApp */
    'launchApp',
    /* version */
    'getVersion',
    'compareVersion'
];
export { apiList };
